/* eslint-disable */
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import AddIcon from '@material-ui/icons/Add';
import withWidth from '@material-ui/core/withWidth';
import PropTypes from 'prop-types';
import React, { createRef } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { bindActionCreators } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import getFiltersAddresses from '../../State/Store/Filters/Selectors/FiltersAddresses.selector';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import ordersActionCreators from '../../State/Store/Orders/Orders.actions';
import ordersAddressesListSelector from '../../State/Store/Orders/Selectors/OrderAddressList.selector';
import ordersAddressesLoadingSelector from '../../State/Store/Orders/Selectors/OrderAddressLoading.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import {
  UI_FILTER_ADDRESS_CLOSED,
  UI_FILTER_ADDRESS_ITEM_REMOVED,
  UI_FILTER_ADDRESS_ITEM_TOGGLED_OFF,
  UI_FILTER_ADDRESS_ITEM_TOGGLED_ON,
  UI_FILTER_ADDRESS_REMOVE_ALL,
  UI_FILTER_ADDRESS_SEARCH_RESULT_SELECTED,
  UI_FILTER_ADDRESS_TOGGLE_ALL,
} from '../../State/Store/UI/UI.types';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import Modal from '../Modal/Modal.component';
import MoreMenu from '../MoreMenu/MoreMenu.component';
import Search from '../Search/Search.component';
import Selections from '../Selections/Selections.component';
import addressSearchStyles from './AddressSearch.component.styles';

/**
 * Address search component
 * @class AddressSearch
 * @extends {React.Component}
 */
class AddressSearchComponent extends React.Component {
  state = {
    open: false,
  };

  searchBarInput = createRef();

  /**
   * onClickAway
   * @returns {void} void
   * @memberof AddressSearchComponent
   */
  onClickAway = () => {
    const { actions } = this.props;
    actions.uiTriggered({ onlyOnce: true, type: UI_FILTER_ADDRESS_CLOSED });
    this.setState({ open: false });
  };

  /**
   * onChange
   * @param {Object} selectedItem selectedItem
   * @param {Object} downshift downshift
   * @returns {void} void
   * @memberof AddressSearchComponent
   */
  onChange = (selectedItem, downshift) => {
    if (!selectedItem) {
      return;
    }
    const { actions } = this.props;
    actions.uiTriggered({ onlyOnce: true, type: UI_FILTER_ADDRESS_SEARCH_RESULT_SELECTED });
    actions.filtersAddAddress(selectedItem);
    this.setState({ open: false });
  };

  /**
   * onRemove
   * @param {string} address address
   * @returns {void} void
   * @memberof AddressSearchComponent
   */
  onRemove = (address) => (event) => {
    const { actions } = this.props;
    actions.uiTriggered({ onlyOnce: true, type: UI_FILTER_ADDRESS_ITEM_REMOVED });
    actions.filtersRemoveAddress(address);
  };

  /**
   * onAddressToggle
   * @param {string} address address
   * @param {string} checked checked
   * @returns {void} void
   * @memberof AddressSearchComponent
   */
  onAddressToggle = (address, checked) => (event) => {
    const { actions } = this.props;
    const toggle = checked ? actions.filtersSelectAddress : actions.filtersUnselectAddress;
    actions.uiTriggered({ onlyOnce: true, type: checked ? UI_FILTER_ADDRESS_ITEM_TOGGLED_ON : UI_FILTER_ADDRESS_ITEM_TOGGLED_OFF });
    toggle(address);
  };

  /**
   * onToggleAll
   * @returns {void} void
   * @memberof AddressSearchComponent
   */
  onToggleAll = () => {
    const { actions } = this.props;
    actions.uiTriggered({ onlyOnce: true, type: UI_FILTER_ADDRESS_TOGGLE_ALL });
    actions.filtersToggleAllAddresses();
  };

  /**
   * onToggleAll
   * @returns {void} void
   * @memberof AddressSearchComponent
   */
  onRemoveAll = () => {
    const { actions } = this.props;
    actions.uiTriggered({ onlyOnce: true, type: UI_FILTER_ADDRESS_REMOVE_ALL });
    actions.filtersRemoveAllAddresses();
  };

  /**
   * onClickSearchBar
   * @param {Object} event event
   * @returns {void} void
   * @memberof AddressSearchComponent
   */
  onClickSearchBar = (event) => {
    event.stopPropagation();
    const { actions } = this.props;
    actions.orderAllAddresses();
    this.setState({
      open: true,
    });
  };

  /**
   * Renders the component
   * @returns {React.Component} component
   * @memberof AddressSearchComponent
   */
  render() {
    const { addressesFilter, classes, currentAccount, services } = this.props;
    const { open } = this.state;
    const excludedItems = Object.keys(addressesFilter);
    const menuItems = [
      [`address-search-toggle-all`, this.onToggleAll, <I18n>OrderService.AddressSearch.Labels.ToggleAll</I18n>],
      [`address-search-remove-all`, this.onRemoveAll, <I18n>OrderService.AddressSearch.Labels.RemoveAll</I18n>],
    ];
    return (
      <React.Fragment>
        <Card classes={{ root: classes.sidebarCard }} elevation={0}>
          <CardHeader
            action={<MoreMenu menuItems={menuItems} />}
            classes={{ action: classes.sidebarCardHeaderAction, root: classes.sidebarCardHeader }}
            title={
              <Grid container justify="space-between">
                <I18n variant="body2">OrdersPage.Sidebar.Address.Heading</I18n>
                <IconButton classes={{ colorInherit: classes.noPadding }} color="inherit" onClick={this.onClickSearchBar}>
                  <AddIcon />
                </IconButton>
              </Grid>
            }
          />

          <CardContent>
            <Grid container direction="column">
              <Grid item>
                <Selections items={addressesFilter} onClickSearchButton={this.onClickSearchBar} onRemove={this.onRemove} onToggle={this.onAddressToggle} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Modal
          content={
            <Search
              currentAccount={currentAccount}
              excludedItems={excludedItems}
              itemsFrom={services.orderService.getAddresses}
              onChange={(el) => this.onChange(el)}
              searchBarInput={this.searchBarInput}
            />
          }
          onClose={this.onClickAway}
          open={open}
          paperClasses={classes.paperClasses}
          title={
            <Grid container>
              <Grid item xs={12}>
                <TextField autoFocus fullWidth inputRef={this.searchBarInput} placeholder="Find an address" type="text" />
              </Grid>
            </Grid>
          }
        />
      </React.Fragment>
    );
  }
}

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
AddressSearchComponent.propTypes = {
  actions: PropTypes.any,
  addressesFilter: PropTypes.any,
  classes: PropTypes.any,
  currentAccount: PropTypes.string,
  services: PropTypes.object,
};

const AddressSearch = compose(
  withStyles(themeCreateInjectableStyles(addressSearchStyles), { withTheme: true }),
  withMobileDialog({ breakpoint: `xs` }),
  withServices,
  withWidth(),
  connect(
    (state) => ({
      addresses: ordersAddressesListSelector(state),
      addressesFilter: getFiltersAddresses(state),
      addressesLoading: ordersAddressesLoadingSelector(state),
      currentAccount: getFiltersSelectedAccount(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...filtersActionCreators,
          ...ordersActionCreators,
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(AddressSearchComponent);

export default AddressSearch;
